import { Observable, fromEvent } from 'rxjs';
import { filter, map, takeWhile } from 'rxjs/operators';

import { Broadcaster, EmitTransport, Messages } from './types';

function isEmitMessage(msg: MessageEvent) {
  return msg != null && msg.data != null && msg.data.type !== 'rpcRequest' && msg.data.type !== 'rpcResponse';
}

/**
 * Do not use 'Emit' from this library if you depend on 'EmitMessages.Action'.
 * Instead use the legacy 'Emit' from @mode/reports/sandbox/api
 * This is because the EmitMessages.Action depends on the legacy 'EmbedBuilderActions'
 */
export const Emit: EmitTransport = {
  getMessageStream: function <T extends Messages>(source: EventTarget): Observable<T> {
    return fromEvent<MessageEvent>(source, 'message').pipe(
      takeWhile(() => source != null),
      filter(isEmitMessage),
      map((msg) => msg.data as T)
    );
  },

  emit: function <T extends Messages>(source: Broadcaster, message: T) {
    // TODO: Fix origin
    source.postMessage(message, '*');
  },
};
